import React from 'react';
import { ListItem, Menu } from '../DefaultMenu/styles';
import homeIcon from '../../assets/images/home_menu_item.svg';
import mapIcon from '../../assets/images/map_menu_item.svg';
import bedIcon from '../../assets/images/bed_menu_item.svg';
import umbrellaIcon from '../../assets/images/umbrella_menu_item.svg';
import hospitalIcon from '../../assets/images/hospital_menu_item.svg';
import newsIcon from '../../assets/images/news_menu_item.svg';
import cameraIcon from '../../assets/images/camera_menu_item.svg';
import experiencesIcon from '../../assets/images/experiences_menu_item.svg';
import calendar from '../../assets/images/calendar.svg';
import notebookTabs from '../../assets/images/notebook-tabs.svg';
import { NavLink } from 'react-router-dom';
import { usePortalContext } from 'common/PortalContext';

const TouristMenu: React.FC = () => {
  const PortalContext = usePortalContext();
  const midiaKitURL = PortalContext?.midiaKitURL;

  return (
    <Menu>
      <ul>
        <ListItem>
          <NavLink activeClassName="selected" exact to="/">
            <img src={homeIcon} alt="icon for list item" />
            <span>Início</span>
          </NavLink>
        </ListItem>
        <ListItem>
          <NavLink activeClassName="selected" to="/how-to-get">
            <img src={mapIcon} alt="icon for list item" />
            <span>Como chegar</span>
          </NavLink>
        </ListItem>
        <ListItem>
          <NavLink activeClassName="selected" to="/accommodations">
            <img src={bedIcon} alt="icon for list item" />
            <span>Onde Ficar</span>
          </NavLink>
        </ListItem>
        <ListItem>
          <NavLink activeClassName="selected" to="/what-to-do">
            <img src={umbrellaIcon} alt="icon for list item" />
            <span>Experiências Turísticas</span>
          </NavLink>
        </ListItem>
        <ListItem>
          <NavLink activeClassName="selected" to="/events">
            <img src={calendar} alt="icon for list item" />
            <span>Agenda</span>
          </NavLink>
        </ListItem>
        <ListItem>
          <NavLink activeClassName="selected" to="/itineraries">
            <img src={notebookTabs} alt="icon for list item" />
            <span>Roteiros</span>
          </NavLink>
        </ListItem>
        <ListItem>
          <NavLink activeClassName="selected" to="/services">
            <img src={hospitalIcon} alt="icon for list item" />
            <span>Serviços Básicos</span>
          </NavLink>
        </ListItem>
        <ListItem>
          <NavLink activeClassName="selected" to="/news">
            <img src={newsIcon} alt="icon for list item" />
            <span>Notícias e Mídias Sociais</span>
          </NavLink>
        </ListItem>
        <ListItem>
          <a href={midiaKitURL} target="_blank" rel="noopener noreferrer">
            <img src={cameraIcon} alt="icon for list item" />
            <span>Mídia Kit</span>
          </a>
        </ListItem>
        <ListItem className="my-experiences">
          <NavLink activeClassName="selected" to="/my-experiences">
            <img src={experiencesIcon} alt="icon for list item" />
            <span>Minhas Experiências</span>
          </NavLink>
        </ListItem>
      </ul>
    </Menu>
  );
};

export default TouristMenu;
